import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { SCREEN_LOGGED } from '../constants/storage';
import { ScreenDto } from 'src/app/shared/dto/screen.dto';
import { LocalStorageService } from './storage.service';

@Injectable({
    providedIn: 'root',
})
export class ScreenLoggedService {
    public screenSubject: Subject<ScreenDto | null> = new Subject();

    private screen: ScreenDto | null = null;
    private readonly localStorageService = inject(LocalStorageService);

    public get screenLogged(): ScreenDto | null {
        return this.screen;
    }

    public set screenLogged(v: ScreenDto | null) {
        this.screen = v;
        this.screenSubject.next(v);
    }

    public setScreen(screen: ScreenDto | null): void {
        this.screenLogged = screen;
        if (screen != null) {
            this.localStorageService.setItem(SCREEN_LOGGED, screen);
        }
    }
}
